// extracted by mini-css-extract-plugin
export default {"section":"OrderDetails_section__lLl82","number_glow":"OrderDetails_number_glow__AEDs7","icon_accepted":"OrderDetails_icon_accepted__6CQD7"};